export const AUTHORIZATION_TOKEN = 'NORTADA_TOKEN';
export const INITIAL_URL = 'NORTADA_INITIAL_URL';
export const CORRELATION_ID = 'CORRELATION_ID';
export const USER_PROFILE = 'USER_PROFILE';
export const NORTADA_CLIENT_ID = 'NORTADA_CLIENT_ID';
export const NORTADA_CLIENT_SECRET = 'NORTADA_CLIENT_SECRET';
export const OTP_PENALTY_TIME = 'OTP_PENALTY_TIME';
export const NAVIGATION_DRAWER_STATE = 'NORTADA_NAVIGATION_DRAWER_STATE';
export const NORTADA_NEW_CLIENT_PROFILE_STEP = 'NORTADA_NEW_CLIENT_PROFILE_STEP';
export const NORTADA_LAST_USER = 'NORTADA_LAST_USER';

// LESTE
/**
 * TODO: LESTE_PREDEFINED_APP_ID and LESTE_EMBEDDED needs to be moved into shared components since
 * it needs to be the same value as in case of leste
 * Don't change these values
 */

export const LESTE_PREDEFINED_APP_ID = 'LESTE_PREDEFINED_APP_ID';
export const LESTE_EMBEDDED = 'LESTE_EMBEDDED';
export const LESTE_MSISDN = 'LESTE_MSISDN';
export const LESTE_TOKEN = 'LESTE_TOKEN';
